export default {
  displayOptionCommission: 'Show commission details',
  displayOptionCommissionLevelV: 'Show commission by levels',
  displayOptionCommissionLevelH: 'Display level (horizontal)',
  searchTitle: 'Filter',
  schoolName: 'School Name',
  schoolNationality: 'Country/Region',
  schoolProvince: 'Province',
  schoolCity: 'City',
  courseLevel: 'Course Level',
  searchContent: 'Enter search content',
  group: 'Group',
  schoolType: 'School Type',
  contractNationality: 'Student Nationality',
  commissionConditionsSearch: 'Commission Condition',
  filter: 'Filter',
  displayLevel: 'Display level only',
  displaySummary: 'Display Summary',
  exportList: 'Export List',
  search: 'Search',
  commissionConditions: 'Commission conditions',
  agentCommission: 'Commission',
  agentMktFee: 'Mkt Fee',
  agentMktFeeRemark: 'Mkt Fee remark',
  agentCommissionRemark: 'commission remark',
  agentFollowCommission: 'Follow-up commission',
  agentFollowCommissionRemark: 'Follow-up commission remark',
  agentProgramTW: 'Programmes',
  agentProgramTWDirect: 'Direct',
  agentProgramTWPush: 'Push',
  agentProgramHK: 'Promotion',
  agentProgramHints: 'For UK UG/PG Students, special marketing rate will be offered if 2 or more students enrolled to our UK Universities.',
  dataTotalNumber: '{totalNumber} record(s) ({totalSchool} school(s))',
  hot: 'Hot',
  new: 'New',
  newDays: 'Days',
  serialNumber: 'No.',
  country: 'Country/Province/City',
  operation: 'Operation',
  commissionRate: 'commission',
  institutionName: 'Institution',
  searchResultEmpty: 'Please modify search criteria.',
  searchResultSameCountry: 'We cannot claim commissions for local student, please modify the search criteria.',
  noPermission: 'No right to access. Please contact administrator.',
  mpsList: 'Commission List',
  naText: 'Not Specified',
  recommend: 'Recommended',
  common: 'Popular',
  recommendTips: 'Data is sorted by popularity',
  commonTips: 'Data is sorted by number of applications',
  otherTips: 'Data is sorted by institution name',
  commonNoDataTips: 'No popular available. You can use recommended.',
  remarkMPSTips: "Note: The actual is subjected to the institution's updated policy and actual payment. GEA reserves the right of final interpretation.",
  countryTips: "Students outside China: Select the country in the filter above, or consult your BD manager.",
}